import React from "react";
import "./App.css"; // Import the CSS file for styling

 function ChequeBouncingCases(){


    return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h2>Cheque Bouncing Cases Page under Construction</h2>



    </div>;


 }


 export default ChequeBouncingCases;